// @ts-ignore
import React, { useEffect, useState } from "react";
import cls from "classnames";
import * as ZXing from "@zxing/library";

import css from "./code.module.scss";
import { postRequest } from "../../services/Requests";
import myHistory from "../../history";
import { Button } from "../button";

const fillColor = "#83f52c";
const paths = [
  "M0 -10 L0 10 M-10 0 L10 0",
  "M-90 -70 l0 -20 l20 0",
  "M90 -70 l0 -20 l-20 0",
  "M-90 70 l0 20 l20 0",
  "M90 70 l0 20 l-20 0",
];

const confirmTicket = async (text: string) => {
  return postRequest<{ orderNumber: string }>({
    url: `booking/confirm/${text}`,
  });
};

export const QRCode = () => {
  const [ status, setStatus ] = useState("In Attesa...");
  const [ qrResult, setResult ] = useState({});
  useEffect(() => {
    const videoElement: HTMLVideoElement = document.getElementById("video");
    navigator.mediaDevices
    .getUserMedia({ audio: false, video: true })
    .then((stream) => {
      videoElement.srcObject = stream;
    });

    const codeReader = new ZXing.BrowserMultiFormatReader();

    codeReader.listVideoInputDevices().then(async (videoDevice) => {
      const frontCam = videoDevice.find((cam) => cam.label.includes("front"));
      const { deviceId } = frontCam || {};

      const result = await codeReader.decodeOnceFromVideoDevice(deviceId, "video");
      setStatus("Verifica");
      try {
        const ticket = await confirmTicket(result.getText());
        setStatus(`Confermato: ${ticket.data.orderNumber}`);
        setTimeout(() => {
          myHistory.goBack();
        }, 2500);
      } catch (error) {
        setStatus("THERE WAS AN ERROR");
      }
    });

    return () => {
      const stream  = videoElement.srcObject;
      videoElement.pause();
      videoElement.srcObject = null;
      videoElement.src = "";
      // @ts-ignore
      stream?.getTracks().forEach((track) => track.stop());
    };
  }, []);
  return (<div className={css["wrapper"]}>
    <h1> Scanerizza il tuo QRCode qui </h1>
    <div className={css["video"]}>
      <video
        autoPlay
        playsInline
        id="video"
        style={{
          objectFit: "cover",
          width: 250,
          height: 250,
        }}
      />
      <svg viewBox="0 0 200 200">
        <g transform="translate(100, 100)">
          {paths.map((d: string) => (<path
            d={d}
            stroke={fillColor}
            fill="transparent"
            strokeLinecap="round"
            strokeWidth={2}
          />))}
        </g>
      </svg>
    </div>
    <div className={css["result"]}>
        <h3 className={css["success"]}> {status} </h3>
    </div>
    <div className={css["back-button"]} >
      <Button
        label="TORNA INDIETRO"
        onClick={() => myHistory.goBack()}
      />
    </div>
  </div>);
};
